<template>
  <div>
    <md-datepicker
      v-model="selectedDate"
      md-immediately
      placeholder="click here to select a day"
    />
    <app-time-slot @click="onTimeSlotClick"></app-time-slot>
  </div>
</template>

<script>
import TimeSlot from "../Shared/TimeSlot";
import { eventBus } from "../eventbus";

export default {
  name: "PickDateTime",
  data: function () {
    return {
      selectedDate: new Date(),
      selectedTime: null,
    };
  },
  components: {
    appTimeSlot: TimeSlot,
  },
  methods: {
    onTimeSlotClick: function (time) {
      this.selectedTime = time;
      this.selectDateTime();
    },

    selectDateTime: function () {
      if (this.selectedDate && this.selectedTime) {
        var t = this.selectedTime.split(":");
        this.selectedDate.setHours(t[0], t[1]);

        this.$store.commit("user/selectDateAndTime", {
          date: this.selectedDate,
          time: this.selectedTime,
        });

        eventBus.selectedDateTime(this.selectedDate, this.selectedTime);
      }
    },
  },
};
</script>

<style>
</style>